import React from "react";
import { useRequestDetails, useComments } from "../../../../hooks";
import { FormSectionsCustomer, FormSectionsNonCustomer } from "./components";

// Main FormSections component
const FormSections = ({
  subForms,
  requestProgressId,
  persona,
  requestId,
  filledForm,
  requestProgress,
  children,
  handleAction,
  isReadOnly = false,
  roleName,
  // Additional props for advanced use cases
  editable = false,
  onFormDataChange = null,
  syncFormSectionsData = null,
  skipApprovalFetch = false,
  errors = null,
  activeTab = null,
  onTabChange = null,
  showRequestBadges = true,
  enableAddComment = true,
  formName = null,
  setComments = () => { },
  hasProductDetails = false,
  hasManufacturersSite = false,
  isSendbackMode = false,
  productDetailsData = null,
  skipCommentsFetch = false,
  externalComments = null,
  customFormsData = null,
}) => {
  const requestDetails = useRequestDetails(requestId, persona) || {};
  
  const {
    prevComments: fetchedComments,
    handleAddComment,
  } = useComments({
    persona,
    requestId,
    skipInitialFetch: skipCommentsFetch,
  });
  
  const prevComments = skipCommentsFetch && externalComments !== null ? externalComments : fetchedComments;
  
  setComments(prevComments);

  const commonProps = {
    subForms,
    requestProgressId,
    prevComments,
    requestDetails: customFormsData ? {...requestDetails, ...customFormsData} : requestDetails,
    requestId,
    filledForm,
    handleAddComment,
    requestProgress,
    children,
    handleAction,
    roleName,
    formName,
    editable,
    onFormDataChange,
    syncFormSectionsData,
    skipApprovalFetch,
    errors,
    activeTab,
    onTabChange,
    showRequestBadges,
    enableAddComment,
    hasProductDetails,
    hasManufacturersSite,
    isSendbackMode,
    productDetailsData,
  };

  if (persona === "customer") {
    return <FormSectionsCustomer {...commonProps} isReadOnly={isReadOnly} />;
  }

  return <FormSectionsNonCustomer {...commonProps} />;
};

export default FormSections;
